import { SentryProvider as IqfSentryProvider } from "iqf-web-ui/sentry";

import { ENV } from "@/env";

export function SentryProvider({ children }: { children: React.ReactNode }) {
  return (
    <IqfSentryProvider
      dev={{
        editor: ENV.VITE_SENTRY_EDITOR,
        rootPath: ENV.VITE_SENTRY_ROOT_PATH,
      }}
      config={{ dsn: ENV.VITE_SENTRY_DSN }}
      mode={ENV.VITE_SENTRY_MODE}
      environment={ENV.VITE_SENTRY_ENVIRONMENT}
      enableFeedback={true}
    >
      {children}
    </IqfSentryProvider>
  );
}
